import { forwardRef, memo, useState } from "react";
import classNames from "classnames";

import { ReactComponent as DragIcon } from "./icons/drag.svg";

import styles from "./style.module.scss";

export default memo<{ [key: string]: any }>(forwardRef<HTMLDivElement, { [key: string]: any }>(((
  {
    isDragging,
    children,
    style,
    onTransitionEnd,
    onDragStart,
    disabled,
    "data-rbd-draggable-context-id": draggableContextId,
    ...props
  }, ref) => {

  const [ hovered, setHovered ] = useState(false);

  return (
    <div
      ref={ref}
      className={classNames(styles.root, { [styles.dragging]: !disabled && (isDragging || hovered) })}
      style={style}
      onTransitionEnd={onTransitionEnd}
      data-rbd-draggable-context-id={draggableContextId}
    >
      <div
        onPointerDown={() => setHovered(true)}
        onPointerUp={() => setHovered(false)}
        onPointerOut={() => setHovered(false)}
        className={classNames(styles.dragButton, { [styles.enabled]: !disabled })}
        data-rbd-draggable-context-id={draggableContextId}
        {...props}
      >
        <DragIcon width={20} height={20} />
      </div>
      {children}
    </div>
  );
})));
